import { render, staticRenderFns } from "./NotificationTemplatesPanel.vue?vue&type=template&id=4b71e972&scoped=true&"
import script from "./NotificationTemplatesPanel.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplatesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationTemplatesPanel.vue?vue&type=style&index=0&id=4b71e972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71e972",
  null
  
)

export default component.exports